var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { withRouter } from 'react-router-dom';
import { SkipReasonEnum } from '@app/AppConstants';
import styles from './SkippedGateView.module.scss';
var SkippedGateViewC = /** @class */ (function (_super) {
    __extends(SkippedGateViewC, _super);
    function SkippedGateViewC() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkippedGateViewC.prototype.render = function () {
        var reasonText = this.props.reason === SkipReasonEnum.Manual ? 'Gate Skipped' : 'Gate Passed in NORRD';
        return React.createElement("div", { className: styles.container },
            "No data (",
            reasonText,
            ")");
    };
    return SkippedGateViewC;
}(React.PureComponent));
export var SkippedGateView = withRouter(SkippedGateViewC);
